import { ReactComponent as ExpandCircleUp } from "assets/icons/design-system/expand-circle-up.svg";
import "./index.scss";

export const CampaignSliderArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={`${className} custom-arrow`}
      style={{ ...style }}
      onClick={onClick}
      data-testid="arrow"
    >
      <ExpandCircleUp id="campaign-slider-arrow" />
    </div>
  );
};
